import { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Shell, PasswordField } from "@/pages/Login";

export default function ResetPassword() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    if (password !== confirm) {
      setErrMsg("Passwords don't match. Please re-enter them.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { code, password });
      toast.success("Password updated — please log in.");
      navigate("/login");
    } catch (err) {
      setErrMsg(apiError(err.response?.data?.detail) || "Could not reset your password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Shell title="Choose a new password" subtitle="Enter a new password for your account.">
      <form onSubmit={submit}>
        <PasswordField label="New password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} testid="reset-password" />
        <PasswordField label="Confirm new password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} testid="reset-confirm-password" />
        {errMsg && <p data-testid="reset-error" className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700">{errMsg}</p>}
        <button type="submit" disabled={loading} data-testid="reset-submit"
          className="w-full rounded-full bg-[var(--brand)] py-3 text-sm font-semibold text-white transition-colors hover:bg-[var(--brand-dark)] disabled:opacity-60">
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-[var(--ink-soft)]"><Link to="/login" className="font-semibold text-[var(--brand)]">Back to log in</Link></p>
    </Shell>
  );
}
